import './ServiceSessionHeader.scss';
import React from 'react';
import StickHeader from '../StickyHeader';

export interface Organization {
    logoUrl?: string;
    name: string;
}

export interface User {
    fullName: string;
    email: string;
    profileUrl: string;
}

export interface ServiceSessionStickyHeaderProps {
    organization: Organization;
    user: User;
    logout: () => void;
}

const ServiceSessionHeader = ({ organization, user, logout }: ServiceSessionStickyHeaderProps) => {
    return (
        <StickHeader classNameRoot="service-session-header">
            <div className="company">
                {organization?.logoUrl && <img className="icon" src={organization.logoUrl} alt="company icon" />}
                <div className="name">{organization?.name} (Service Session Active)</div>
            </div>
            <div className="servicedUser">
                <div className="name">
                    Currently logged in as {user?.fullName} ({user?.email}) -
                    <div className="logout" onClick={logout}>
                        Log Out
                    </div>
                </div>
                <img className="profile" src={user?.profileUrl} alt="user profile" />
            </div>
        </StickHeader>
    );
};

export default ServiceSessionHeader;
